<script>
	import router from "../../stores/router";
	import base from "../../stores/base";
	import view from "../../stores/view";
	import UIIcon from "../UIIcon.svelte";
	import { fade } from "svelte/transition";
	import { quartOut } from "svelte/easing";
	let isOpen = false;
	let selectedMenu = "";

	function slide() {
		return {
			duration: 400,
			easing: quartOut,
			css: (t) => `transform:translateX(${100 * (1 - t)}%)`,
		};
	}

	$: {
		selectedMenu = $router.params.category
			? "/" + $router.params.category
			: $router.path;
		isOpen = false;
	}
</script>

<header class="Header">
	<div class="Header-box">
		<div class="Header-logo">
			<a href="/"><img src="/img/logo.png" alt="ずっとびロゴ" /></a>
		</div>
		{#if $view.mode === "sp"}
			<nav
				class="Header-toggle"
				on:click={() => {
					isOpen = !isOpen;
				}}
			>
				<div>
					{#if isOpen}
						<UIIcon type="cross" color="#bb5858" size={32} />
					{:else}
						<UIIcon type="menu" color="#bb5858" size={32} />
					{/if}
				</div>
				<p>MENU</p>
			</nav>
			{#if isOpen}
				<div class="Header-panel">
					<div
						class="Header-panel-base"
						transition:fade={{ duration: 100 }}
						on:click={() => (isOpen = false)}
					/>
					<div class="Header-panel-box" transition:slide>
						<nav class="Header-panel-nav">
							{#each $base.menu as { url, label }}
								<a
									href={url}
									on:click|preventDefault={() =>
										router.push(url)}
								>
									<span>{@html label[$base.lang]}</span></a
								>
							{/each}
						</nav>
						<nav class="Header-panel-lang">
							<a
								href="/"
								on:click|preventDefault={() => {
									base.setLang("ja");
								}}
								class="Header-lang-btn"
								class:_selected={$base.lang === "ja"}>日本語</a
							><a
								href="/"
								on:click|preventDefault={() => {
									base.setLang("en");
								}}
								class="Header-lang-btn"
								class:_selected={$base.lang === "en"}>English</a
							>
						</nav>
					</div>
				</div>
			{/if}
		{:else}
			<nav class="Header-nav">
				{#each $base.menu as { url, label }}
					<a
						href={url}
						class:_selected={selectedMenu === url}
						on:click|preventDefault={() => router.push(url)}
						>{@html label[$base.lang].split("\n").join("<br>")}</a
					>
				{/each}
			</nav>
			<nav class="Header-lang">
				<a
					href="/"
					on:click|preventDefault={() => {
						base.setLang("ja");
					}}
					class="Header-lang-btn"
					class:_selected={$base.lang === "ja"}>日本語</a
				><a
					href="/"
					on:click|preventDefault={() => {
						base.setLang("en");
					}}
					class="Header-lang-btn"
					class:_selected={$base.lang === "en"}>English</a
				>
			</nav>
		{/if}
	</div>
</header>

<style global>
	.Header {
		position: fixed;
		width: 100%;
		z-index: 5;
	}
	.Header-box {
		width: 100%;
		height: 60px;
		border-bottom: 1px solid #ccc;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 1em;
		background: #fff;
	}
	:global(.pc) .Header-box {
		height: 100px;
		padding: 0 3.75em;
		justify-content: center;/* 言語切り替えボタンない場合 */
	}
	@media screen and (min-width: 920px) and (max-width: 1420px) {
		:global(.pc) .Header-box {
			height: 100px;
			padding: 0 1.5em;
		}
	}

	.Header-logo > a {
		display: inline-block;
		border: 1px dashed transparent;
	}
	.Header-logo > a:focus-visible {
		border-color: #bb5858;
	}

	.Header-logo img {
		width: 80px;
		height: auto;
	}
	:global(.pc) .Header-logo img {
		width: 148px;
	}
	@media screen and (min-width: 920px) and (max-width: 1420px) {
		:global(.pc) .Header-logo img {
			width: 110px;
		}
	}
	.Header-toggle {
		font-size: 0.7em;
		line-height: 1;
		text-align: center;
		color: #bb5858;
		width: 40px;
		z-index: 2;
	}
	.Header-toggle p {
		white-space: nowrap;
	}
	.Header-nav {
		display: flex;
		align-items: center;
		padding-right:10px;/* 言語切り替えボタンない場合 */
		margin:0 auto;/* 言語切り替えボタンない場合 */
	}

	.Header-nav > a {
		display: inline-block;
		padding: 0 0.8em;
		color: #524e4e;
		border-bottom: 1px solid transparent;
		line-height: 1.3;
		text-align: center;
		font-size: 1.25em;
		transition: 0.3s;
		background: url(../img/h_border.png) left center no-repeat;
	}
	@media screen and (min-width: 920px) and (max-width: 1420px) {
		.Header-nav > a {
			padding: 0 1em;
			font-size: 1em;
		}
	}

	.Header-nav > a:first-child {
		background: none;
	}
	.Header-nav span {
		font-size: 0.8em;
	}
	.Header-nav > a:hover {
		color: #bb5858;
	}
	.Header-nav > a:focus-visible {
		border-bottom: 1px dashed #bb5858;
	}

	.Header-nav > a._selected {
		color: #bb5858;
	}

	.Header-lang {
		white-space: nowrap;
	}
	.Header-lang-btn {
		display: inline-block;
		padding: 0.25em 1em;
		color: #bb5858;
		border: 1px solid #bb5858;
		font-size: 1em;
	}
	@media screen and (min-width: 920px) and (max-width: 1420px) {
		.Header-lang-btn {
			font-size: 0.82em;
		}
	}
	.Header-lang-btn._selected {
		pointer-events: none;
		background: #bb5858;
		color: #fff;
		border-color: #bb5858;
	}
	.Header-lang-btn:first-child {
		border-top-left-radius: 20px;
		border-bottom-left-radius: 20px;
		border-right: none;
	}
	.Header-lang-btn:last-child {
		border-top-right-radius: 20px;
		border-bottom-right-radius: 20px;
	}
	.Header-lang-btn:focus-visible {
		border: 1px dashed #bb5858;
	}

	/* SP PANEL ********** */

	.Header-panel {
		position: absolute;
		top: 0;
		right: 0;
		z-index: 1;
		width: 100%;
		height: 100vh;
	}
	.Header-panel-base {
		position: absolute;
		top: 0;
		right: 0;
		z-index: 1;
		width: 100%;
		height: 100vh;
		background: rgba(0, 0, 0, 0.2);
	}
	.Header-panel-box {
		position: absolute;
		top: 0;
		right: 0;
		width: 70%;
		height: 100vh;
		background: #fff;
		z-index: 2;
		padding-top: 60px;
	}

	.Header-panel-nav > a {
		display: block;
		font-size: 1.3em;
		padding: 1em 0 1em 2em;
		color: #bb5858;
	}
	.Header-panel-nav > a > * {
		display: inline-block;
		vertical-align: middle;
		margin-right: 0.25em;
	}
	.Header-panel-nav > a span {
		padding-left: 0.5em;
		border-left: 2px solid #ddabab;
	}
	.Header-panel-lang {
		text-align: center;
		font-size: 1.1em;
		padding: 2em 1em 1em 1em;
	}
</style>
